
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from "@angular/common";
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { TaskLabel } from '../../taskbook.types';

@Component({
  selector: 'create-task-label-dialog',
  templateUrl: './create-task-label-dialog.component.html',
  styleUrls: ['create-task-label-dialog.component.scss'],
    standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
]
})
export class CreateOrEditTaskLabelDialogComponent implements OnInit {

    taskLabelNameCtrl = new FormControl<string>('', [Validators.required, Validators.minLength(1)]);

    availableColors = ["#e9ecef","#ced4da","#adb5bd","#6c757d","#495057",
                        "#f94144","#f3722c","#f8961e","#f9844a","#f9c74f",
                         "#f9414455","#f3722c55","#f8961e55","#f9844a55","#f9c74f55",
                        "#90be6d","#43aa8b","#4d908e","#577590","#277da1",
                        "#90be6d55","#43aa8b55","#4d908e55","#57759055","#277da155"
                        ];
    
      
    selectedColor = this.availableColors[0];

    label: TaskLabel = {
        id: crypto.randomUUID(),
        name: '',
        color: ''
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: TaskLabelDialogData,
        private dialogRef: MatDialogRef<CreateOrEditTaskLabelDialogComponent>,
    ) { }

    ngOnInit(): void {
        this.label.name = this.data.label.name ? this.data.label.name : '';
        this.taskLabelNameCtrl.setValue(this.data.label.name);

        if(this.data.mode === 'edit'){
            this.selectedColor = this.data.label.color;
            this.label.id = this.data.label.id;
        }

        this.taskLabelNameCtrl.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap(async () => {
                this.label.name = this.taskLabelNameCtrl.getRawValue();
            })
        ).subscribe();
    }

    selectColor(color: string){
        this.selectedColor = color;
    }

    save(){
        this.label.color = this.selectedColor;
        this.dialogRef.close(this.label);
    }

    close(){
        this.dialogRef.close(null);
    }
}

interface TaskLabelDialogData{
    label: TaskLabel
    mode: 'create' | 'edit'
}

